import { useTranslation } from "react-i18next";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import { AsyncCallArgs, CircularLoader, useAsyncCall, ViewDialog, ViewSection } from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../hooks/redux/base/useAppSelector";
import React, { useEffect, useState } from "react";
import { getFullGroupDetails } from "../../../../../axios/api/services";
import { closeModal } from "../../../../../store/redux/slice/ComponentsControl/groupsControl";
import MainDetailsDisplay from "./parts/MainDetailsDisplay";
import UsersDialogList from "../../users/dialog/parts/UsersDialogList";
import RolesDialogList from "./parts/RolesDialogList";
import ScrollableGridContainer from "../../../common/grid/ScrollableGridContainer";
import GroupHierarchyContent from "./parts/GroupHierarchyContent";
import InheritedRolesContent from "./parts/InheritedRolesContent";

const GroupViewDialog = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { asyncCall } = useAsyncCall();

  const { open, id } = useAppSelector((state) => {
    return state.ComponentsControl.groupsControl.modals.view;
  });

  const [group, setGroup] = useState(null);

  useEffect(() => {
    if (open && id) {
      const getGroupCallArgs: AsyncCallArgs = {
        promise: getFullGroupDetails(id),
        onSuccess: (response) => {
          setGroup(response);
        },
        onError: () => {
          setGroup(null);
          dispatch(closeModal({ modalType: "view" }));
        },
      };
      asyncCall(getGroupCallArgs);
    }
  }, [open, id, asyncCall, dispatch, t]);

  return (
    <div>
      <ViewDialog
        open={open}
        onClose={() => {
          dispatch(closeModal({ modalType: "view" }));
          setGroup(null);
        }}
        title={"t.group.view.dialog"}
      >
        {!group && <CircularLoader />}
        {group && (
          <>
            <ViewSection label={"t.hierarchy.details"}>
              <GroupHierarchyContent group={group} modalType={"view"} />
            </ViewSection>
            <MainDetailsDisplay record={group.group} />

            {group?.group?.parentGroup?.id && (
              <ViewSection label={"t.inherited.roles"}>
                <InheritedRolesContent group={group} />
              </ViewSection>
            )}

            <ViewSection label={"t.group.roles"}>
              <ScrollableGridContainer>
                <RolesDialogList roles={group.roles} isEdit={false} />
              </ScrollableGridContainer>
            </ViewSection>

            <ViewSection label={"t.group.users"}>
              <ScrollableGridContainer>
                <UsersDialogList users={group.users} isEdit={false} />
              </ScrollableGridContainer>
            </ViewSection>
          </>
        )}
      </ViewDialog>
    </div>
  );
};

export default GroupViewDialog;
